import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';



export const getIndustries = (callback?: (result: any, error: any) => void): actionsInterfaces.IGetIndustriesAction => {
  return {
    type: actionsTypes.GET_INDUSTRIES,    
    callback
  };  
};

export const setIndustries = (industries: actionsInterfaces.Industry[]): actionsInterfaces.ISetIndustriesAction => {
  return {
    type: actionsTypes.SET_INDUSTRIES,
    industries    
  };
};

